import http from '@/utils/http'

// 公开信息列表（新闻资讯、政策法规、公共通知、业务指南）
export function getDepositList(query) {
  return http.get('/api/maintenance-fund/weixin/deposit/list', {
    params: query
  })
}


export function fetchDepositList(data) {
  return http.get('/api/wx/public/deposit/list',data)
}
